import highlights from '@/mixins/search/highlights'

export default {
  mixins: [highlights],
  props: {
    highlights: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    index: {
      type: String,
      required: true
    },
    highlightsLoading: {
      type: Boolean,
      required: true
    },
    link: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      missionPrefix: '<span class="t-500">Mission: </span>',
      researchTopicPrefix: '<span class="t-500">Ongoing Research: </span>',
      publicationPrefix: '<span class="t-500">Publication: </span>',
      projectPrefix: '<span class="t-500">Project: </span>'
    }
  },
  computed: {
    name () {
      return this.highlights && this.highlights.name ? this.highlights.name[0] : this.data.name
    },
    owners () {
      return this.data.owners
    },
    description () {
      if (!this.isEmpty(this.abstractDescription)) {
        return `${this.publicationPrefix} ${this.abstractDescription}`
      } else if (!this.isEmpty(this.projectDescription)) {
        return `${this.projectPrefix} ${this.projectDescription}`
      } else if (!this.isEmpty(this.researchTopicDescription)) {
        return `${this.researchTopicPrefix} ${this.researchTopicDescription}`
      } else if (!this.isEmpty(this.clinicalTrialDescription)) {
        return `${this.clinicalTrialPrefix} ${this.clinicalTrialDescription}`
      } else if (!this.isEmpty(this.descriptionDescription)) {
        return `${this.missionPrefix} ${this.descriptionDescription}`
      }

      return (this.data.description) ? `${this.missionPrefix} ${this.stripTagsNoMark(this.data.description)}` : ''
    },
    organisation () {
      return !this.isEmpty(this.data.organisation) ? this.data.organisation : { name: this.data.organisation_name }
    }
  }
}
